const getters = {
	yxxnstate: state => state.yxxnstate,
	dqzs: state => state.dqzs,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js